import { render, staticRenderFns } from "./tableother.vue?vue&type=template&id=4325b704&"
import script from "./tableother.vue?vue&type=script&lang=js&"
export * from "./tableother.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports